'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalStyle = {
  'body, html': {
    margin: 0,
    fontFamily: 'TradeGothicLTStd-Cn18',
    boxSizing: 'border-box',
    backgroundColor: '#FAFAFA',
    height: '100%'
  },
  '#content': {
    height: '100%'
  },
  a: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: 'inherit',
    padding: 0,
    fontFamily: 'TradeGothicLTStd-Cn18',
    boxSizing: 'border-box'
  },
  '*': {
    boxSizing: 'inherit'
  }
};

(0, _keys2.default)(globalStyle).forEach(function (selector) {
  var style = globalStyle[selector];

  _glamor.css.global(selector, style);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/styles/global.style.js
// module id = 753
// module chunks = 0